import { postJson } from '../net/http';
import log from '../log';
import { MQ } from './mq';
import { config_api_proxy_host, config_sync_proxy_host, defKKAuth, KKAuth } from '.';
import { ErrorCodePermission } from '../../src/net/http';
import { Str_AuthorizeHadExpired } from '../../src/language/string_res';
import * as ImSdk from "../api/index";

export type StatusListener = (status: string) => void;

type Config = {
    SyncHost: string; // sync的地址 -- web端这个是本地代理标签
};

// 与服务器的连接
export class Connection {
    private auth: KKAuth = defKKAuth
    private mq: MQ;
    private isClose: boolean = false;

    constructor(mq: MQ) {
        this.mq = mq;
    }

    public SetAuth(auth: KKAuth) {
        this.auth = auth;
    }

    public Close() {
        this.isClose = true;
        // todo 后续再补充其它控制逻辑
    }

    private async onErrorCodePermission(uid: number, token: string, res?: any) {
        const auth = await ImSdk.getInstance().getAuth(uid);

        if (auth && auth.auth && auth.auth.token !== token) {
            // 说明是重新登录的已经登录过的账号
            return
        }
        const msg = res.msg || res.message || Str_AuthorizeHadExpired;
        this.mq.emit('auth_fail', { auth_fail: { vcode: this.auth.vcode, msg }, });
    }


    public Call<T>(path: string, body: any): any {
        return new Promise((resolve) => {
            let uri  = config_api_proxy_host() + path;
            if (path.startsWith('/sync')) {
                uri = config_sync_proxy_host() + path;
            }

            // 记录发出去时的token和uid
            const token = this.auth.token;
            const uid = this.auth.uid;
            let req = { body: body, headers: { 'X-Token': token } };
            // console.log('===>>>> start fetch1111: ' + uri, body, req.headers);
            postJson<T, Config>(uri, req)
                .then(async (res) => {
                    if (res && res.config) {
                        const c = res.config as Config;
                        log.info('更新config', c);
                    }
                    if (res && res.code === ErrorCodePermission) {
                        this.onErrorCodePermission(uid, token, res);
                        return;

                    }
                    resolve(res);
                })
                .catch((err) => {
                    resolve({ code: -1, error: err });
                });
        });
    }
}
